export const MAINTENANCE_MODE = false; // flip to true to block the whole app, redeploy
